import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
}

.hn-account-page {
  max-width: 1080px;
}

.hn-account-overview {
  align-items: center;
  background: radial-gradient(circle at 88% 0, rgba(169, 201, 92, 0.14), transparent 280px), var(--hn-charcoal);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-shadow: var(--hn-shadow-md);
  color: #fff;
  display: grid;
  gap: 13px;
  grid-template-columns: 54px minmax(180px, 1fr) auto auto;
  margin-top: 12px;
  min-height: 78px;
  padding: 13px 15px;
}

.hn-account-avatar {
  align-items: center;
  background: var(--hn-accent);
  border: 1px solid #96b24f;
  border-radius: 11px;
  color: var(--hn-accent-ink);
  display: flex;
  font-size: 21px;
  font-weight: 900;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.hn-account-overview__identity {
  min-width: 0;
}

.hn-account-overview__identity strong,
.hn-account-overview__identity small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-account-overview__identity strong {
  font-size: 19px;
  font-weight: 800;
}

.hn-account-overview__identity small {
  color: rgba(255, 255, 255, 0.64);
  font-size: 14px;
  margin-top: 3px;
}

.hn-account-meta {
  display: flex;
  margin: 0;
}

.hn-account-meta > div {
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  min-width: 105px;
  padding: 2px 18px;
}

.hn-account-meta dt {
  color: rgba(255, 255, 255, 0.62);
  font-size: 13px;
  font-weight: 600;
}

.hn-account-meta dd {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin: 3px 0 0;
}

.hn-logout {
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.78);
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  gap: 8px;
  justify-content: center;
  min-height: 44px;
  padding: 0 13px;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), color 0.16s var(--hn-ease);
}

.hn-logout:hover:not(:disabled) {
  background: rgba(191, 64, 52, 0.18);
  border-color: rgba(255, 150, 136, 0.5);
  color: #ffaaa0;
}

.hn-logout:disabled {
  opacity: 0.5;
}

.hn-logout__icon {
  fill: none;
  flex: 0 0 16px;
  height: 16px;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  width: 16px;
}

.hn-account-tabs {
  align-items: center;
  background: rgba(242, 244, 239, 0.94);
  border: 1px solid var(--hn-line);
  border-radius: 14px;
  display: flex;
  gap: 3px;
  margin-top: 10px;
  padding: 3px;
  position: sticky;
  top: 0;
  z-index: 8;
}

.hn-account-tabs a {
  align-items: center;
  border-radius: 9px;
  color: var(--hn-muted-strong);
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 13px;
  text-decoration: none;
  transition: background-color 0.16s var(--hn-ease), color 0.16s var(--hn-ease);
}

.hn-account-tabs a:hover,
.hn-account-tabs a:focus-visible,
.hn-account-tabs a.is-active {
  background: var(--hn-paper);
  color: var(--hn-ink);
}

.hn-account-tabs a.is-active {
  box-shadow: inset 0 -2px 0 var(--hn-accent-deep);
}

.hn-account-tabs a i {
  color: var(--hn-accent-deep);
  font-size: 13px;
}

.hn-account-main {
  display: grid;
  gap: 10px;
  margin-top: 10px;
  min-width: 0;
}

.hn-account-notice,
.hn-account-loading,
.hn-account-error {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: var(--hn-radius);
  min-height: 54px;
  padding: 11px 14px;
}

.hn-account-notice {
  align-items: center;
  border-color: #d6e7b7;
  display: flex;
  gap: 11px;
}

.hn-account-notice > i {
  color: var(--hn-accent-deep);
  font-size: 15px;
}

.hn-account-notice p {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

.hn-account-notice.is-error {
  background: var(--hn-danger-soft);
  border-color: #efbeb7;
}

.hn-account-notice.is-error > i {
  color: var(--hn-danger);
}

.hn-account-notice.is-warning {
  background: var(--hn-warn-soft);
  border-color: #ead29f;
}

.hn-account-notice.is-warning > i {
  color: var(--hn-warn);
}

.hn-account-loading {
  align-items: center;
  display: flex;
  gap: 13px;
}

.hn-account-loading > span {
  animation: hn-account-pulse 0.8s ease-in-out infinite alternate;
  background: var(--hn-accent);
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.hn-account-loading strong {
  font-size: 14px;
}

.hn-account-error {
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: space-between;
}

.hn-account-error strong {
  color: var(--hn-danger);
  display: block;
  font-size: 14px;
}

.hn-account-error p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 5px 0 0;
}

.hn-account-error button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 9px;
  color: var(--hn-ink);
  font-size: 14px;
  font-weight: 700;
  min-height: 44px;
  padding: 0 13px;
}

.hn-code-panel {
  align-items: center;
  background: var(--hn-charcoal);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: var(--hn-radius-lg);
  box-shadow: var(--hn-shadow-md);
  color: #fff;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(210px, 0.8fr) minmax(250px, 1fr) auto;
  overflow: hidden;
  padding: 17px 19px;
  scroll-margin-top: 72px;
}

.hn-code-panel__copy > span {
  color: var(--hn-accent);
  display: block;
  font-size: 14px;
  font-weight: 800;
}

.hn-code-panel__copy > strong {
  display: block;
  font-size: 17px;
  margin-top: 7px;
}

.hn-code-panel__copy > p {
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  line-height: 1.45;
  margin: 6px 0 0;
}

.hn-code-panel code {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  color: #fff;
  font-size: clamp(17px, 2vw, 22px);
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  letter-spacing: 0.07em;
  overflow-wrap: anywhere;
  padding: 14px 16px;
  text-align: center;
}

.hn-code-panel__actions {
  display: flex;
  gap: 8px;
}

.hn-account-group {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: var(--hn-radius-lg);
  box-shadow: none;
  overflow: hidden;
  scroll-margin-top: 72px;
}

.hn-account-group[hidden] {
  display: none !important;
}

.hn-account-group__head {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: flex;
  gap: 14px;
  min-height: 62px;
  padding: 13px 18px;
}

.hn-account-group__head > span {
  align-items: center;
  background: var(--hn-accent-soft);
  border-radius: 12px;
  color: var(--hn-accent-deep);
  display: flex;
  flex: 0 0 36px;
  height: 36px;
  justify-content: center;
}

.hn-account-group__head > span i {
  font-size: 15px;
}

.hn-account-group__head h2 {
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.025em;
  margin: 0;
}

.hn-account-group__head p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 3px 0 0;
}

.hn-account-block {
  background: transparent;
  border: 0;
  display: block;
  margin: 0;
  padding: 18px;
}

.hn-account-block + .hn-account-block {
  border-top: 1px solid var(--hn-line);
}

.hn-account-block__head {
  margin-bottom: 14px;
}

.hn-account-block__head--actions {
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: space-between;
}

.hn-account-block__head h3 {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 0;
}

.hn-account-block__head p {
  color: var(--hn-muted);
  font-size: 14px;
  line-height: 1.5;
  margin: 6px 0 0;
}

.hn-account-block__head p strong {
  color: var(--hn-ink);
  overflow-wrap: anywhere;
}

.hn-form-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: 1fr 1fr;
}

.hn-field {
  display: block;
  min-width: 0;
}

.hn-field--wide {
  grid-column: 1/-1;
}

.hn-field > span,
.hn-field-heading > span,
.hn-field-heading > label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
}

.hn-field > span em {
  color: var(--hn-muted);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  margin-left: 6px;
}

.hn-field-heading {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.hn-field-heading > span,
.hn-field-heading > label {
  margin-bottom: 8px;
}

.hn-field-heading button {
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: var(--hn-accent-deep);
  font-size: 14px;
  font-weight: 800;
  min-height: 44px;
  padding: 0 4px 5px 12px;
}

.hn-field-heading button:hover {
  color: var(--hn-ink);
}

.hn-field input {
  background: var(--hn-paper-soft);
  border: 1px solid var(--hn-line-strong);
  border-radius: 10px;
  color: var(--hn-ink);
  font-size: 15px;
  min-height: 50px;
  padding: 0 14px;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), box-shadow 0.16s var(--hn-ease);
  width: 100%;
}

.hn-field input::placeholder {
  color: #80887f;
  opacity: 1;
}

.hn-field input:focus {
  background: #fff;
  border-color: var(--hn-accent-deep);
  box-shadow: 0 0 0 3px rgba(168, 200, 93, 0.18);
}

.hn-field input[aria-invalid=true] {
  border-color: var(--hn-danger);
  box-shadow: 0 0 0 3px rgba(217, 76, 58, 0.12);
}

.hn-field-error {
  color: var(--hn-danger);
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-top: 7px;
}

.hn-block-note,
.hn-inline-warning {
  border-radius: 9px;
  font-size: 14px;
  line-height: 1.45;
  margin-top: 12px;
  padding: 9px 11px;
}

.hn-block-note {
  background: var(--hn-paper-muted);
  color: var(--hn-muted-strong);
}

.hn-inline-warning {
  background: var(--hn-warn-soft);
  border: 1px solid #ead29f;
  color: #6b4a14;
  font-weight: 700;
}

.hn-block-actions {
  border-top: 1px solid var(--hn-line);
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  padding-top: 14px;
}

.hn-primary-button,
.hn-secondary-button {
  align-items: center;
  border-radius: 9px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 800;
  gap: 8px;
  justify-content: center;
  min-height: 44px;
  padding: 0 15px;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), transform 0.16s var(--hn-ease);
}

.hn-primary-button {
  background: var(--hn-charcoal);
  border: 1px solid var(--hn-charcoal);
  color: #fff;
}

.hn-primary-button:hover:not(:disabled) {
  background: #252b23;
  transform: translateY(-1px);
}

.hn-secondary-button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  color: var(--hn-ink);
}

.hn-secondary-button:hover:not(:disabled) {
  background: var(--hn-paper-soft);
  border-color: var(--hn-muted);
}

.hn-secondary-button.is-danger {
  background: var(--hn-danger-soft);
  border-color: #e9aaa1;
  color: var(--hn-danger);
}

.hn-primary-button:disabled,
.hn-secondary-button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.hn-code-panel .hn-secondary-button {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.hn-recovery-row {
  align-items: end;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(0, 1fr) auto;
}

.hn-recovery-row > .hn-secondary-button {
  min-height: 50px;
}

.hn-session-list,
.hn-activity-list {
  border-top: 1px solid var(--hn-line);
}

.hn-session-item {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: grid;
  gap: 14px;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  min-height: 70px;
  padding: 10px 6px;
}

.hn-session-item.is-current {
  background: var(--hn-accent-soft);
}

.hn-session-icon {
  align-items: center;
  background: var(--hn-paper-muted);
  border-radius: 9px;
  color: var(--hn-muted-strong);
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.hn-session-item.is-current .hn-session-icon {
  background: var(--hn-paper);
  color: var(--hn-accent-deep);
}

.hn-session-icon i {
  font-size: 14px;
}

.hn-session-item strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

.hn-session-item p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.hn-session-item small {
  color: var(--hn-muted);
  display: block;
  font-size: 14px;
  margin-top: 4px;
  overflow-wrap: anywhere;
}

.hn-current-session {
  background: var(--hn-paper);
  border: 1px solid #d2e4b1;
  border-radius: 7px;
  color: var(--hn-accent-deep);
  font-size: 14px;
  font-weight: 800;
  padding: 6px 8px;
}

.hn-session-item > button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 8px;
  color: var(--hn-ink);
  font-size: 14px;
  font-weight: 700;
  min-height: 44px;
  padding: 0 12px;
}

.hn-session-item > button:hover:not(:disabled) {
  background: var(--hn-danger-soft);
  border-color: #e9aaa1;
  color: var(--hn-danger);
}

.hn-activity-list article {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: grid;
  gap: 13px;
  grid-template-columns: 9px minmax(0, 1fr) auto;
  min-height: 58px;
  padding: 9px 4px;
}

.hn-activity-list article > span {
  background: var(--hn-accent);
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.hn-activity-list strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

.hn-activity-list p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.hn-activity-list time {
  color: var(--hn-muted);
  font-size: 14px;
  white-space: nowrap;
}

.hn-empty-activity {
  color: var(--hn-muted);
  font-size: 14px;
  padding: 22px 2px;
}

@keyframes hn-account-pulse {
  to {
    opacity: 0.3;
    transform: scale(0.78);
  }
}
@media (max-width: 840px) {
  .hn-account-overview {
    grid-template-columns: 54px minmax(0, 1fr) auto;
  }
  .hn-account-meta {
    display: none;
  }
  .hn-code-panel {
    grid-template-columns: 1fr;
  }
  .hn-code-panel__actions {
    justify-content: flex-start;
  }
}
@media (max-width: 620px) {
  .hn-account-overview {
    gap: 11px;
    grid-template-columns: 44px minmax(0, 1fr) auto;
    margin-top: 10px;
    min-height: 70px;
    padding: 11px;
  }
  .hn-account-avatar {
    border-radius: 12px;
    font-size: 18px;
    height: 48px;
    width: 48px;
  }
  .hn-account-overview__identity strong {
    font-size: 17px;
  }
  .hn-logout {
    font-size: 0;
    padding: 0;
    width: 44px;
  }
  .hn-logout__icon {
    height: 17px;
    width: 17px;
  }
  .hn-account-tabs {
    margin-top: 9px;
    overflow-x: auto;
  }
  .hn-account-tabs a {
    flex: 1 0 auto;
    justify-content: center;
    min-height: 44px;
    padding: 0 10px;
  }
  .hn-account-main {
    gap: 9px;
    margin-top: 9px;
  }
  .hn-account-group {
    scroll-margin-top: 66px;
  }
  .hn-account-group__head {
    min-height: 60px;
    padding: 11px 14px;
  }
  .hn-account-group__head > span {
    flex-basis: 38px;
    height: 38px;
  }
  .hn-account-group__head h2 {
    font-size: 19px;
  }
  .hn-account-block {
    padding: 16px 14px;
  }
  .hn-account-block__head--actions {
    align-items: stretch;
    flex-direction: column;
  }
  .hn-form-grid {
    grid-template-columns: 1fr;
  }
  .hn-field--wide {
    grid-column: auto;
  }
  .hn-field-heading button {
    min-height: 44px;
  }
  .hn-field input {
    font-size: 16px;
  }
  .hn-block-actions .hn-primary-button {
    min-height: 48px;
    width: 100%;
  }
  .hn-recovery-row {
    grid-template-columns: 1fr;
  }
  .hn-code-panel {
    gap: 14px;
    padding: 16px 14px;
  }
  .hn-code-panel__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .hn-account-error {
    align-items: stretch;
    flex-direction: column;
  }
  .hn-session-item {
    align-items: start;
    grid-template-columns: 40px minmax(0, 1fr);
    padding: 15px 3px;
  }
  .hn-session-item > button,
  .hn-current-session {
    grid-column: 2;
    justify-self: start;
  }
  .hn-activity-list article {
    align-items: start;
    grid-template-columns: 8px minmax(0, 1fr);
  }
  .hn-activity-list time {
    grid-column: 2;
  }
}
@media (max-width: 380px) {
  .hn-account-overview__identity small {
    max-width: 170px;
  }
  .hn-code-panel__actions {
    grid-template-columns: 1fr;
  }
  .hn-account-tabs a {
    font-size: 14px;
  }
}`],
})
export class PageMypageComponent implements OnInit, OnDestroy {
    public user: any = null;
    public sessions: any[] = [];
    public activity: any[] = [];
    public recovery: any = { has_code: false, updated: null };
    public loading = true;
    public loadError = '';
    public busyAction = '';
    public pageNotice: any = null;
    public fieldErrors: any = {};
    public activeSection = 'profile';

    public profileForm: any = { name: '', mobile: '' };
    public emailForm: any = { new_email: '', confirm_email: '', current_password: '' };
    public passwordForm: any = { current_password: '', new_password: '', confirm_password: '' };
    public recoveryPassword = '';
    public recoveryIssueConfirmed = false;
    public recoveryCode = '';
    public recoveryNotice = '';
    public recoveryCodeCopied = false;
    public visiblePasswords: any = {};

    private readonly emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.activeSection = this.sectionFromLocation();
        await this.load();
    }

    public ngOnDestroy() {
        this.emailForm = { new_email: '', confirm_email: '', current_password: '' };
        this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        this.recoveryPassword = '';
        this.recoveryCode = '';
    }

    @HostListener('window:beforeunload', ['$event'])
    public protectRecoveryCode(event: BeforeUnloadEvent) {
        if (!this.recoveryCode) return;
        event.preventDefault();
        event.returnValue = '';
    }

    public canDeactivate(): boolean {
        if (!this.recoveryCode) return true;
        return window.confirm('새 복구 코드를 아직 저장하지 않았습니다. 이 화면을 나갈까요?');
    }

    public get otherSessionCount() {
        return this.sessions.filter((item) => !item.is_current).length;
    }

    public async load(showLoading: boolean = true) {
        if (showLoading) this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('get');
            if (code !== 200 || !data?.user) {
                this.loadError = this.message(data, '계정 정보를 불러오지 못했습니다.');
                return;
            }

            this.user = data.user;
            this.sessions = data.sessions || [];
            this.activity = data.activity || [];
            this.recovery = data.recovery || { has_code: false, updated: null };
            this.profileForm = {
                name: this.user.name || '',
                mobile: this.user.mobile || ''
            };
            this.syncHeader();
        } catch (error) {
            this.loadError = '계정 정보를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private sectionFromLocation() {
        const section = String(location.hash || '').replace(/^#/, '');
        return ['profile', 'security', 'sessions'].includes(section)
            ? section
            : 'profile';
    }

    private motionBehavior(): ScrollBehavior {
        return typeof window.matchMedia === 'function'
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth';
    }

    public setActiveSection(section: string) {
        this.activeSection = section;
    }

    public onTabKeydown(event: KeyboardEvent, current: string) {
        const sections = ['profile', 'security', 'sessions'];
        const currentIndex = sections.indexOf(current);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % sections.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + sections.length) % sections.length;
        } else if (event.key === 'Home') {
            nextIndex = 0;
        } else if (event.key === 'End') {
            nextIndex = sections.length - 1;
        } else {
            return;
        }

        event.preventDefault();
        const next = sections[nextIndex];
        this.activeSection = next;
        window.history.replaceState(null, '', `${location.pathname}${location.search}#${next}`);
        void this.service.render();
        setTimeout(() => document.getElementById(`hn-account-tab-${next}`)?.focus());
    }

    @HostListener('window:hashchange')
    public syncSectionFromHash() {
        this.activeSection = this.sectionFromLocation();
        void this.service.render();
    }

    private message(data: any, fallback: string) {
        return (data && data.message) || (typeof data === 'string' ? data : fallback);
    }

    private syncHeader() {
        if (!this.user || !this.service.auth.session) return;
        this.service.auth.session.name = this.user.name;
        this.service.auth.session.email = this.user.email;
    }

    private clearFeedback() {
        this.pageNotice = null;
        this.fieldErrors = {};
    }

    private applyError(data: any, fallback: string) {
        let field = data?.field;
        if (field === 'current_password' && this.busyAction === 'email') field = 'email_password';
        if (field === 'current_password' && this.busyAction === 'password') field = 'password_current';
        const message = this.message(data, fallback);
        if (field) this.fieldErrors[field] = message;
        this.pageNotice = { type: 'error', message };
        const selectors: any = {
            name: '[name="profile_name"]',
            mobile: '[name="profile_mobile"]',
            new_email: '[name="new_email"]',
            confirm_email: '[name="confirm_email"]',
            email_password: '#hn-email-current-password',
            password_current: '#hn-password-current',
            new_password: '#hn-password-new',
            confirm_password: '[name="confirm_password"]',
            recovery_password: '#hn-recovery-current-password'
        };
        setTimeout(() => {
            const input = field ? document.querySelector(selectors[field]) as HTMLElement : null;
            const target = input || document.querySelector('.hn-account-notice') as HTMLElement;
            if (!target) return;
            if (!input) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
            target.scrollIntoView({ block: 'center', behavior: this.motionBehavior() });
        }, 20);
    }

    private setSuccess(message: string) {
        this.fieldErrors = {};
        this.pageNotice = { type: 'success', message };
    }

    private focusNotice() {
        setTimeout(() => {
            const notice = document.querySelector('.hn-account-notice') as HTMLElement;
            if (!notice) return;
            notice.focus({ preventScroll: true });
            notice.scrollIntoView({ block: 'center', behavior: this.motionBehavior() });
        }, 20);
    }

    private async startAction(name: string) {
        this.clearFeedback();
        this.recoveryIssueConfirmed = false;
        this.busyAction = name;
        await this.service.render();
    }

    private async finishAction() {
        this.busyAction = '';
        await this.service.render();
    }

    private async showRecoveryCode(code: string, message: string) {
        this.recoveryCode = code || '';
        this.recoveryCodeCopied = false;
        this.recoveryNotice = message;
        await this.service.render();
        setTimeout(() => {
            const panel = document.getElementById('new-recovery-code');
            panel?.focus({ preventScroll: true });
            panel?.scrollIntoView({ block: 'start', behavior: this.motionBehavior() });
        }, 0);
    }

    public clearFieldError(field: string) {
        if (this.fieldErrors[field]) delete this.fieldErrors[field];
        if (this.pageNotice?.type === 'error') this.pageNotice = null;
    }

    public resetRecoveryConfirmation() {
        this.recoveryIssueConfirmed = false;
    }

    public async togglePassword(field: string) {
        this.visiblePasswords[field] = !this.visiblePasswords[field];
        await this.service.render();
    }

    public async updateProfile() {
        if (this.busyAction) return;
        const name = String(this.profileForm.name || '').trim();
        const mobile = String(this.profileForm.mobile || '').trim();
        if (!name) {
            this.applyError({ field: 'name', message: '이름을 입력해주세요.' }, '이름을 입력해주세요.');
            await this.service.render();
            return;
        }
        if (name.length > 50) {
            this.applyError({ field: 'name', message: '이름은 50자 이내로 입력해주세요.' }, '이름을 확인해주세요.');
            await this.service.render();
            return;
        }

        await this.startAction('profile');
        try {
            const { code, data } = await wiz.call('update_profile', { name, mobile });
            if (code === 200 && data?.user) {
                this.user = data.user;
                this.profileForm = { name: data.user.name || '', mobile: data.user.mobile || '' };
                this.syncHeader();
                this.setSuccess('기본 정보를 저장했습니다.');
            } else {
                this.applyError(data, '기본 정보를 저장하지 못했습니다.');
            }
        } catch (error) {
            this.applyError(null, '기본 정보 저장 요청을 완료하지 못했습니다.');
        } finally {
            await this.finishAction();
        }
    }

    public async changeEmail() {
        if (this.busyAction) return;
        const payload = {
            new_email: String(this.emailForm.new_email || '').trim().toLowerCase(),
            confirm_email: String(this.emailForm.confirm_email || '').trim().toLowerCase(),
            current_password: String(this.emailForm.current_password || '')
        };
        if (!payload.new_email) {
            this.applyError({ field: 'new_email', message: '새 이메일을 입력해주세요.' }, '새 이메일을 입력해주세요.');
            await this.service.render();
            return;
        }
        if (!payload.confirm_email) {
            this.applyError({ field: 'confirm_email', message: '새 이메일을 한 번 더 입력해주세요.' }, '새 이메일을 확인해주세요.');
            await this.service.render();
            return;
        }
        if (!payload.current_password) {
            this.applyError({ field: 'email_password', message: '현재 비밀번호를 입력해주세요.' }, '현재 비밀번호를 입력해주세요.');
            await this.service.render();
            return;
        }
        if (!this.emailPattern.test(payload.new_email)) {
            this.applyError({ field: 'new_email', message: '이메일 형식을 확인해주세요.' }, '이메일을 확인해주세요.');
            await this.service.render();
            return;
        }
        if (payload.new_email !== payload.confirm_email) {
            this.applyError({ field: 'confirm_email', message: '새 이메일이 일치하지 않습니다.' }, '이메일을 확인해주세요.');
            await this.service.render();
            return;
        }

        await this.startAction('email');
        try {
            const { code, data } = await wiz.call('change_email', payload);
            if (code === 200 && data?.user && data?.recovery_code) {
                this.user = data.user;
                this.emailForm = { new_email: '', confirm_email: '', current_password: '' };
                this.syncHeader();
                this.setSuccess('로그인 이메일을 변경했습니다.');
                await this.showRecoveryCode(data.recovery_code, '이메일 변경으로 기존 복구 코드는 폐기됐습니다.');
                await this.load(false);
            } else {
                this.applyError(data, '로그인 이메일을 변경하지 못했습니다.');
            }
        } catch (error) {
            this.applyError(null, '이메일 변경 요청을 완료하지 못했습니다.');
        } finally {
            await this.finishAction();
        }
    }

    public async changePassword() {
        if (this.busyAction) return;
        const payload = {
            current_password: String(this.passwordForm.current_password || ''),
            new_password: String(this.passwordForm.new_password || ''),
            confirm_password: String(this.passwordForm.confirm_password || '')
        };
        if (!payload.current_password) {
            this.applyError({ field: 'password_current', message: '현재 비밀번호를 입력해주세요.' }, '현재 비밀번호를 입력해주세요.');
            await this.service.render();
            return;
        }
        if (!payload.new_password) {
            this.applyError({ field: 'new_password', message: '새 비밀번호를 입력해주세요.' }, '새 비밀번호를 입력해주세요.');
            await this.service.render();
            return;
        }
        if (!payload.confirm_password) {
            this.applyError({ field: 'confirm_password', message: '새 비밀번호를 한 번 더 입력해주세요.' }, '새 비밀번호를 확인해주세요.');
            await this.service.render();
            return;
        }
        if (payload.new_password.length < 8) {
            this.applyError({ field: 'new_password', message: '새 비밀번호는 8자 이상이어야 합니다.' }, '비밀번호를 확인해주세요.');
            await this.service.render();
            return;
        }
        if (payload.new_password !== payload.confirm_password) {
            this.applyError({ field: 'confirm_password', message: '새 비밀번호가 일치하지 않습니다.' }, '비밀번호를 확인해주세요.');
            await this.service.render();
            return;
        }

        await this.startAction('password');
        try {
            const { code, data } = await wiz.call('change_password', payload);
            if (code === 200 && data?.recovery_code) {
                this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
                this.setSuccess('비밀번호를 변경했습니다.');
                await this.showRecoveryCode(data.recovery_code, '비밀번호 변경으로 기존 복구 코드는 폐기됐습니다.');
                await this.load(false);
            } else {
                this.applyError(data, '비밀번호를 변경하지 못했습니다.');
            }
        } catch (error) {
            this.applyError(null, '비밀번호 변경 요청을 완료하지 못했습니다.');
        } finally {
            await this.finishAction();
        }
    }

    public async issueRecoveryCode() {
        if (this.busyAction) return;
        if (!this.recoveryPassword) {
            this.applyError({ field: 'recovery_password', message: '현재 비밀번호를 입력해주세요.' }, '현재 비밀번호를 입력해주세요.');
            await this.service.render();
            return;
        }
        if (!this.recoveryIssueConfirmed) {
            this.recoveryIssueConfirmed = true;
            this.pageNotice = null;
            await this.service.render();
            return;
        }

        await this.startAction('recovery');
        try {
            const { code, data } = await wiz.call('issue_recovery_code', { current_password: this.recoveryPassword });
            if (code === 200 && data?.recovery_code) {
                this.recoveryPassword = '';
                this.recoveryIssueConfirmed = false;
                this.setSuccess('새 복구 코드를 발급했습니다.');
                await this.showRecoveryCode(data.recovery_code, '기존 복구 코드는 더 이상 사용할 수 없습니다.');
                await this.load(false);
            } else {
                this.applyError(data, '복구 코드를 발급하지 못했습니다.');
            }
        } catch (error) {
            this.applyError(null, '복구 코드 발급 요청을 완료하지 못했습니다.');
        } finally {
            await this.finishAction();
        }
    }

    public async copyRecoveryCode() {
        if (!this.recoveryCode) return;
        try {
            await navigator.clipboard.writeText(this.recoveryCode);
            this.recoveryCodeCopied = true;
            this.recoveryNotice = '복구 코드를 복사했습니다.';
        } catch (error) {
            this.recoveryNotice = '코드를 직접 복사해 안전한 장소에 보관해주세요.';
        }
        await this.service.render();
    }

    public async acknowledgeRecoveryCode() {
        this.recoveryCode = '';
        this.recoveryCodeCopied = false;
        this.recoveryNotice = '';
        await this.service.render();
    }

    public async revokeSession(item: any) {
        if (this.busyAction || !item?.id || item.is_current) return;
        await this.startAction('session-' + item.id);
        try {
            const { code, data } = await wiz.call('revoke_login_session', { session_id: item.id });
            if (code === 200) {
                this.sessions = data?.sessions || [];
                this.setSuccess('선택한 기기의 로그인을 종료했습니다.');
                await this.load(false);
                this.focusNotice();
            } else {
                this.applyError(data, '로그인을 종료하지 못했습니다.');
            }
        } catch (error) {
            this.applyError(null, '로그인 종료 요청을 완료하지 못했습니다.');
        } finally {
            await this.finishAction();
        }
    }

    public async revokeOtherSessions() {
        if (this.busyAction || !this.otherSessionCount) return;
        const confirmed = await this.service.modal.warning(
            `다른 기기 ${this.otherSessionCount}대의 로그인을 모두 종료할까요?`,
            '취소',
            '모두 로그아웃'
        );
        if (!confirmed) return;
        await this.startAction('sessions');
        try {
            const { code, data } = await wiz.call('revoke_other_sessions', {});
            if (code === 200) {
                this.sessions = data?.sessions || [];
                this.setSuccess('다른 기기의 로그인을 모두 종료했습니다.');
                await this.load(false);
                this.focusNotice();
            } else {
                this.applyError(data, '다른 로그인을 종료하지 못했습니다.');
            }
        } catch (error) {
            this.applyError(null, '로그인 종료 요청을 완료하지 못했습니다.');
        } finally {
            await this.finishAction();
        }
    }

    public activityLabel(action: string) {
        const labels: any = {
            signup: '관리자 계정 생성',
            login: '로그인',
            logout: '로그아웃',
            profile_update: '기본 정보 변경',
            email_change: '로그인 이메일 변경',
            password_change: '비밀번호 변경',
            password_reset: '복구 코드로 비밀번호 재설정',
            recovery_rotate: '복구 코드 재발급',
            session_revoke: '로그인 기기 종료',
            sessions_revoke: '다른 기기 모두 로그아웃',
            shadow_start: '운용 시스템 시작',
            shadow_stop: '운용 시스템 중지',
            settings_reauth_failed: '민감 설정 비밀번호 확인 실패',
            settings_reauth_locked: '민감 설정 비밀번호 확인 잠금',
            kis_credentials_updated: 'KIS 연결 정보 변경',
            kis_credentials_cleared: 'KIS 연결 해제',
            live_budget_updated: '운용 금액 변경',
            live_budget_approved: '운용 금액 승인',
            strategy_settings_updated: '전략 설정 변경',
            live_account_prepared: 'LIVE 계좌 확인 완료'
        };
        return labels[action] || '계정 설정 변경';
    }

    public formatDate(value: any) {
        if (!value) return '기록 없음';
        const source = String(value);
        const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(source)
            ? source.replace(' ', 'T') + 'Z'
            : source;
        const date = new Date(normalized);
        if (Number.isNaN(date.getTime())) return source;
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

    public async logout() {
        if (this.busyAction) return;
        await this.startAction('logout');
        try {
            const { code, data } = await wiz.call('logout', {});
            if (code === 200) {
                location.replace('/access');
                return;
            }
            this.applyError(data, '로그아웃하지 못했습니다.');
        } catch (error) {
            this.applyError(null, '로그아웃 요청을 완료하지 못했습니다.');
        }
        await this.finishAction();
    }
}

export default PageMypageComponent;